import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { HeaderComponent } from './core/layout/header/header.component';
import { LegalConsentModal } from './core/layout/legal-consent-modal/legal-consent-modal';
import { ThemeService } from './core/services/theme.service';

/** Rotas que se bastam: mostrar o menu nelas seria oferecer uma saída. */
const ROTAS_SEM_HEADER = ['/boas-vindas'];

/**
 * Casca do app. O gradiente de fundo saiu do Tailwind literal para o token
 * `--bf-shell` (spec 011 RF16): é ele que troca de afinação entre o modo
 * claro e o noturno.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, HeaderComponent, LegalConsentModal],
  host: {
    class: 'block app-shell',
  },
})
export class AppComponent {
  // Injetado aqui para que o tema seja aplicado no bootstrap, antes da 1ª pintura.
  private readonly theme = inject(ThemeService);
  private readonly router = inject(Router);

  private readonly url = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  /**
   * O onboarding (spec 018) esconde o header de propósito. O guard já barra as
   * telas de aluno, mas o menu ainda levaria a `/perfil` e `/artigos` — e uma
   * tela que existe para reter alguém não pode exibir a porta ao lado.
   */
  protected readonly showHeader = computed(
    () => !ROTAS_SEM_HEADER.some((rota) => this.url().startsWith(rota)),
  );
}
